import React, { useState, useRef } from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiUploadCloud, FiFile, FiAlertCircle } from 'react-icons/fi';
import { validateFile } from '../utils/helpers';
import { uploadFile } from '../lib/api';

const UploadArea = ({ onUploadSuccess }) => {
  const [isDragging, setIsDragging] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);
  const fileInputRef = useRef(null);

  const handleFile = async (file) => {
    setError(null);
    const validation = validateFile(file);
    if (!validation.valid) {
      setError(validation.error);
      return;
    }

    setUploading(true);
    try {
      await uploadFile(file);
      setUploading(false);
      onUploadSuccess();
    } catch (err) {
      setError(err.message);
      setUploading(false);
    }
  };

  const onDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      handleFile(e.dataTransfer.files[0]);
    }
  };

  return (
    <div className="bg-[#f0f7fb] rounded-2xl p-2 sm:p-4">
      <div 
        className={`border-2 border-dashed rounded-xl p-10 text-center transition-all duration-200 bg-white ${isDragging ? 'border-[#f39200] shadow-md scale-[1.01]' : 'border-[#005b9f]/30 hover:border-[#005b9f]/60'}`}
        onDragOver={(e) => { e.preventDefault(); setIsDragging(true); }}
        onDragLeave={() => setIsDragging(false)}
        onDrop={onDrop}
      >
        <input 
          type="file" 
          ref={fileInputRef} 
          className="hidden" 
          onChange={(e) => e.target.files && handleFile(e.target.files[0])} 
        />
        
        {!uploading ? (
          <div className="flex flex-col items-center cursor-pointer" onClick={() => fileInputRef.current?.click()}>
            <div className="p-5 bg-[#f0f7fb] rounded-full mb-6 text-[#005b9f]">
              <SafeIcon icon={FiUploadCloud} className="w-10 h-10" />
            </div>
            <h3 className="text-xl font-bold text-[#005b9f] mb-2">Datei hier ablegen oder klicken</h3>
            <p className="text-gray-500 mb-6 max-w-md mx-auto">
              Sicherer Upload auf den Reisering-Server. PDF, Bilder, Office-Dokumente und ZIP erlaubt.
            </p>
            <button className="px-8 py-3 bg-[#005b9f] text-white rounded-full hover:bg-[#004a82] transition-colors font-bold shadow-md">
              Datei auswählen
            </button>
          </div>
        ) : (
          <div className="flex flex-col items-center py-8">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#005b9f] mb-6"></div>
            <p className="text-sm font-bold text-[#005b9f]">Datei wird auf den Server übertragen...</p>
          </div>
        )}
      </div>

      {error && (
        <div className="mt-4 p-4 bg-red-50 border border-red-200 rounded-xl text-red-700 flex items-center mx-2">
          <SafeIcon icon={FiAlertCircle} className="w-5 h-5 mr-3 flex-shrink-0" />
          <p className="text-sm font-medium">{error}</p>
        </div>
      )}
    </div>
  );
};

export default UploadArea;